function textAnswers(state = {}, action) {
  switch (action.type) {
    case 'TEXT_CHANGED' : {
      const newState = { ...state };
      newState[action.evalId] = {
        text: action.value,
        check: action.value.length === 0
      };
      return newState;
    }
    case 'CHECKBOX_CHANGED' : {
      const newState = { ...state };
      newState[action.evalId] = {
        text: state[action.evalId] ? state[action.evalId].text : '',
        check: action.value
      };
      return newState;
    }
    case 'DATA_RECEIVED' : {
      const newState = {};
      Object.keys(action.data['text_answers']).forEach(key => {
        newState[key] = {
          text: action.data['text_answers'][key] || '',
          check: action.data['text_answers'][key] === null
        };
      });
      return newState;
    }
    default:
      return state;
  }
}

export default textAnswers;
